/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerCreatedBy } from './success-card-transaction-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerErrors } from './success-card-transaction-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerInvoiceIssuer } from './success-card-transaction-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerUpdatedBy } from './success-card-transaction-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerUploadedBy } from './success-card-transaction-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionEvidenceListInnerWarnings } from './success-card-transaction-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInner
 */
export interface SuccessCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'paymentType': SuccessCardTransactionEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'electronicMethod': SuccessCardTransactionEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'documentSize': SuccessCardTransactionEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'legalValidity': SuccessCardTransactionEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerInvoiceIssuer}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'invoiceIssuer': SuccessCardTransactionEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'dpiError': SuccessCardTransactionEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'colorGradationError': SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'heightMillisError': SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'widthMillisError': SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerErrors}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'errors': SuccessCardTransactionEvidenceListInnerErrors;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerWarnings}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'warnings': SuccessCardTransactionEvidenceListInnerWarnings;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'createdBy': SuccessCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerUpdatedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'updatedBy': SuccessCardTransactionEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerUploadedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedBy': SuccessCardTransactionEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedFrom': string;
}

export const SuccessCardTransactionEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type SuccessCardTransactionEvidenceListInnerPaymentTypeEnum = typeof SuccessCardTransactionEvidenceListInnerPaymentTypeEnum[keyof typeof SuccessCardTransactionEvidenceListInnerPaymentTypeEnum];
export const SuccessCardTransactionEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerElectronicMethodEnum = typeof SuccessCardTransactionEvidenceListInnerElectronicMethodEnum[keyof typeof SuccessCardTransactionEvidenceListInnerElectronicMethodEnum];
export const SuccessCardTransactionEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDocumentSizeEnum = typeof SuccessCardTransactionEvidenceListInnerDocumentSizeEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDocumentSizeEnum];
export const SuccessCardTransactionEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type SuccessCardTransactionEvidenceListInnerLegalValidityEnum = typeof SuccessCardTransactionEvidenceListInnerLegalValidityEnum[keyof typeof SuccessCardTransactionEvidenceListInnerLegalValidityEnum];
export const SuccessCardTransactionEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum = typeof SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum];
export const SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum = typeof SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum];
export const SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum = typeof SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum];


